
import type { ISumbitPassword, IUpdatePassword } from '@/api/user';
import { defineComponent, reactive } from 'vue';
import { useRoute } from 'vue-router';
import { useUserStore } from '@/store/modules/user';
import { ElMessage } from 'element-plus';
import { CloseBold } from '@element-plus/icons';
import { FILESERVICE } from '@/config/defaultSetting';

export default defineComponent({
  name: 'UpdaPassWord',
  components: {
    CloseBold,
  },
  props: {
    username: {
      type: String,
      default: '',
    },
    showCloseBtn: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['closeDia'],
  setup(prop, context) {
    const userStore = useUserStore();
    const route = useRoute();
    const changePasswordData: IUpdatePassword = reactive({
      oldPassword: '',
      newPassword: '',
      newPasswordRe: '',
    });
    const rules = reactive({
      oldPassword: [
        { required: true, message: '请输入旧密码', trigger: 'blur' },
      ],
      newPassword: [{ validator: validatePass, trigger: 'blur' }] as any[],
      newPasswordRe: [{ validator: validatePass2, trigger: 'blur' }],
    });
    function onChangePassword() {
      const params: ISumbitPassword = {
        userName: prop.username,
        oldPassword: window.btoa(changePasswordData.oldPassword),
        newPassword: window.btoa(changePasswordData.newPassword),
        newPasswordRe: window.btoa(changePasswordData.newPasswordRe),
      };
      userStore
        .changePassword(params)
        .then(() => {
          ElMessage.success({
            message: '修改成功',
            type: 'success',
          });
          onClose();
        })
        .catch((error) => {
          throw new Error(error);
        });
    }
    function onClose() {
      if (route.name === 'login') {
        userStore.resetState();
      }
      context.emit('closeDia', undefined);
    }
    function validatePass(
      rule: any,
      value: string,
      callback: (arg0?: Error | undefined) => void
    ) {
      if (value === '') {
        callback(new Error('请输入新密码'));
      } else {
        callback();
      }
    }
    function validatePass2(
      rule: any,
      value: string,
      callback: (arg0?: Error | undefined) => void
    ) {
      if (value === '') {
        callback(new Error('请再次输入新密码'));
      } else if (value !== changePasswordData.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    }

    const getPasswordPolicy = async () => {
      const result = await userStore.getPasswordPolicy();
      rules.newPassword.push({
        required: true,
        pattern: result.regexp,
        message: result.regexpTips,
        trigger: 'blur',
      });
    };
    getPasswordPolicy();

    return {
      changePasswordData,
      onChangePassword,
      onClose,
      rules,
      FILESERVICE,
    };
  },
});
